import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import { youtubeApproval } from "../redux/actions/SessionAction";
import { ZoomMeetingRecording } from "../redux/actions/ZoomMeeting";

const VideoApprovalModal = ({ meetingRecording, sessioId, meetingNo }) => {
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [show, setShow] = useState(false);
  const [channelLink, setChannelLink] = useState("");
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const youtubeRequest = (e) => {
    setLoader(true)
    e.preventDefault();

    if (!meetingRecording) {
      //fetching zoom url if meeting url doesnt exist
      const data = {
        meetingId: meetingNo
      };
      const onSuccess = (data) => {
        console.log("zoom url fetching");
        const youtubedata = {
          videoUrl: data.recording_files[0].play_url,
          sessionId: sessioId,
          youtubeChannel:channelLink
        };
        const onSuccess = (data) => {
          openSnackbar(data);
          setLoader(false)
          handleClose()
        };
        const onError = (data) => {
            openSnackbar(data);
          setLoader(false)
          handleClose()
        };
        dispatch(youtubeApproval(youtubedata, onSuccess, onError));
      };
      const onError = () => {
        handleClose()
        setLoader(false)
        openSnackbar("Recording not found for this session !!");
      };
      dispatch(ZoomMeetingRecording(data, onSuccess, onError));
    } else {
      const data = {
        videoUrl: meetingRecording,
        sessionId: sessioId,
        youtubeChannel:channelLink
      };
      const onSuccess = (data) => {
        openSnackbar(data);
        setLoader(false)
      };
      const onError = (data) => {
        openSnackbar(data);
        setLoader(false)
      };
      dispatch(youtubeApproval(data, onSuccess, onError));
    }
  };

  return (
    <>
      <Button className="col-12 approval" onClick={handleShow}>
        <i class="fab fa-youtube"></i> Request YouTube Approval
      </Button>
      <Modal show={show} onHide={handleClose}>

        <Modal.Body>
          <Form onSubmit={(e)=>youtubeRequest(e)}>
            <Form.Group className="mb-3" >
              <Form.Label>Youtube channel link :</Form.Label>
              <Form.Control
                type="text"
                value={channelLink}
                onChange={(e)=>setChannelLink(e.target.value)}
                required
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={loader}>
                Request
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VideoApprovalModal;
